// extracted by mini-css-extract-plugin
export default {"cardContainer":"blogCard_cardContainer__bKbyh","thumbnailContainer":"blogCard_thumbnailContainer__jqbpU","blogInfoContainer":"blogCard_blogInfoContainer__sKbhi"};